import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pt-5" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("form", {
  action: "",
  id: "securityAndLogin"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "mb-4" }, [
    /*#__PURE__*/_createElementVNode("label", {
      for: "oldPassword",
      class: "form-label"
    }, "Old Password"),
    /*#__PURE__*/_createElementVNode("input", {
      type: "password",
      class: "form-control border-lightgreen bg-header",
      id: "oldPassword",
      "aria-describedby": "oldPasswordHelp"
    }),
    /*#__PURE__*/_createElementVNode("div", {
      id: "oldPasswordHelp",
      class: "form-text text-white opacity-50"
    }, " Please enter your old password. ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "mb-4" }, [
    /*#__PURE__*/_createElementVNode("label", {
      for: "newPassword",
      class: "form-label"
    }, "New Password"),
    /*#__PURE__*/_createElementVNode("input", {
      type: "password",
      class: "form-control border-lightgreen bg-header",
      id: "newPassword",
      "aria-describedby": "newPasswordHelp"
    }),
    /*#__PURE__*/_createElementVNode("div", {
      id: "newPasswordHelp",
      class: "form-text text-white opacity-50"
    }, " Your new passwrod must contains at least 8 characters including a number and a special character. ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "mb-4" }, [
    /*#__PURE__*/_createElementVNode("label", {
      for: "confirmPassword",
      class: "form-label"
    }, "Confirm New Password"),
    /*#__PURE__*/_createElementVNode("input", {
      type: "password",
      class: "form-control border-lightgreen bg-header",
      id: "confirmPassword",
      "aria-describedby": "confirmPasswordHelp"
    }),
    /*#__PURE__*/_createElementVNode("div", {
      id: "confirmPasswordHelp",
      class: "form-text text-white opacity-50"
    }, " Re-enter your New Password ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "d-grid gap-3 d-md-flex justify-content-md-start py-3" }, [
    /*#__PURE__*/_createElementVNode("button", {
      type: "submit",
      class: "btn btn-primary rounded-0 py-2 px-4"
    }, " Update Password "),
    /*#__PURE__*/_createElementVNode("button", {
      type: "submit",
      class: "btn btn-outline-white rounded-0 py-2 px-4"
    }, " Cancel ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "border-bottom border-2 border-lightgreen pb-3 pt-5" }, [
    /*#__PURE__*/_createElementVNode("h4", { class: "pt-3" }, "Login")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "form-check form-switch form-check-reverse pt-5" }, [
    /*#__PURE__*/_createElementVNode("input", {
      class: "form-check-input px-4 bg-header",
      type: "checkbox",
      role: "switch",
      id: "saveLogin",
      checked: ""
    }),
    /*#__PURE__*/_createElementVNode("label", {
      class: "form-check-label d-flex justify-content-start",
      for: "saveLogin"
    }, "Save your Login information")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "border-bottom border-2 border-lightgreen pb-3 pt-5" }, [
    /*#__PURE__*/_createElementVNode("h4", { class: "pt-3" }, "Delete My Account")
  ]),
  /*#__PURE__*/_createElementVNode("p", { class: "pt-5 pb-3" }, " Deleting your account removes your access to this account and all of its information. Are you sure? "),
  /*#__PURE__*/_createElementVNode("div", { class: "d-grid gap-3 d-md-flex justify-content-md-start py-3" }, [
    /*#__PURE__*/_createElementVNode("button", {
      type: "button",
      class: "btn btn-danger d-grid gap-3 d-md-flex text-white rounded-0 py-2 px-4",
      id: "deleteAccount",
      "data-bs-toggle": "modal",
      "data-bs-target": "#confirmDeletion"
    }, " Delete My Account ")
  ]),
  /*#__PURE__*/_createElementVNode("div", {
    class: "modal fade",
    id: "confirmDeletion",
    tabindex: "-1",
    "aria-labelledby": "confirmDeletionlLabel",
    "aria-hidden": "true"
  }, [
    /*#__PURE__*/_createElementVNode("div", { class: "modal-dialog" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "modal-content text-black rounded-2" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
          /*#__PURE__*/_createElementVNode("h1", {
            class: "modal-title fs-5 ps-3",
            id: "confirmDeletionLabel"
          }, " Delete Account "),
          /*#__PURE__*/_createElementVNode("button", {
            type: "button",
            class: "btn-close",
            "data-bs-dismiss": "modal",
            "aria-label": "Close"
          })
        ]),
        /*#__PURE__*/_createElementVNode("div", { class: "modal-body" }, [
          /*#__PURE__*/_createElementVNode("div", { class: "mb-4 p-3" }, [
            /*#__PURE__*/_createElementVNode("label", {
              for: "confimation",
              class: "form-label"
            }, "Please enter your password to confirm this action."),
            /*#__PURE__*/_createElementVNode("input", {
              type: "password",
              class: "form-control border-dark",
              id: "confirmation"
            })
          ])
        ]),
        /*#__PURE__*/_createElementVNode("div", { class: "modal-footer" }, [
          /*#__PURE__*/_createElementVNode("button", {
            type: "button",
            class: "btn btn-outline-dark rounded-0",
            "data-bs-dismiss": "modal"
          }, " Cancel "),
          /*#__PURE__*/_createElementVNode("button", {
            type: "submit",
            class: "btn btn-danger text-white rounded-0"
          }, " Confirm ")
        ])
      ])
    ])
  ])
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}